import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {DEFAULT_FLAG_SIZE, DEFAULT_PER_PAGE} from "../../config";
import {Button, Col, Pagination, Row, Space, Table, Tag, Tooltip} from "antd";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {StatusIndicator} from "../shared/Status";
import {Link} from "react-router-dom";
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import qs from "qs";
import Flag from "react-world-flags";
import IPAddressesTableFilter from "./IPAddressesTableFilter";
import {adminLoadIPAddresses} from "../../actions/network";

class IPAddressesTable extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true, position: ['topRight', 'bottomRight'] },
        ipAddresses: [],
        loadingIPAddresses: true,
        filters: [],
        showFiltersModal: false,
        activeIPAddress: null,
        showIPAddressReplacementModal: false,
        selectedIPAddresses: [],
        showChangeIPAddressStatusModal: false
    }

    componentDidMount() {
        this.props.updatePage('IP Addresses');
        this.updateFilterFromHistoryChange();
    }

    updateFilterFromHistoryChange() {
        let queryString = qs.parse(window.location.search.substring(1));

        let filters = [];

        if('group' in queryString) {
            filters.push({
                name: 'Group',
                key: 'group',
                value: queryString['group'],
                visible: null
            });
        }

        if(filters.length === 0) {
            this.adminLoadIPAddresses();
        } else {
            this.setState({ filters }, () => this.adminLoadIPAddresses());
        }
    }

    adminLoadIPAddresses(page = null, per_page = null, scroll_top = true) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingIPAddresses: true });

        this.props.adminLoadIPAddresses(page, per_page, this.state.filters, (res) => {
            if(scroll_top) {
                window.scrollTo(0, 0);
            }

            this.setState({ ipAddresses: res.data.data, loadingIPAddresses: false,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingIPAddresses: false });
                displayErrors(err.response.data);
            }
        });
    }

    onTableChange(pagination) {
        this.adminLoadIPAddresses(pagination.current, pagination.pageSize);
    }

    clearFilters() {
        this.setState({ filters: [], page: 1, per_page: this.state.pagination.pageSize }, () => this.adminLoadIPAddresses());
    }

    setFilter(filter) {
        let filters = this.state.filters.filter(f => f.key !== filter.key);
        filters.push(filter);

        this.setState({ filters, page: 1, per_page: this.state.pagination.pageSize }, () => this.adminLoadIPAddresses());
    }

    removeFilter(item) {
        let filters = this.state.filters.filter(filter => filter.key !== item.key);
        this.setState({ filters }, () => this.adminLoadIPAddresses());
    }

    showFilters() {
        return this.state.filters.map((filter, i) => {
            let value;

            if (typeof filter.value === 'boolean') {
                if (filter.value) {
                    value = 'Yes';
                } else {
                    value = 'No';
                }
            } else {
                if (filter.visible !== null) {
                    value = filter.visible;
                } else {
                    value = normalizeEnum(filter.value);
                }
            }

            return <Tag key={i} closable onClose={() => this.removeFilter(filter)}>{filter.name}: {value}</Tag>;
        });
    }

    setGroupFilter(record, e) {
        e.target.parentElement.blur();

        let filters = this.state.filters.filter(filter => filter.key !== 'group');

        filters.push({
            name: 'Group',
            key: 'group',
            value: record.group.guid,
            visible: record.group.name
        });

        this.setState({ filters }, () => this.adminLoadIPAddresses());
    }

    render() {
        const columns = [
            { title: 'ID', dataIndex: 'id'},
            { title: 'IP address', dataIndex: 'ip_address' },
            { title: 'Status', align: 'center', dataIndex: 'status', render: (item) => <StatusIndicator status={item} el='badge' />},
            { title: 'Type', dataIndex: 'ip_address_type', render: (item) => normalizeEnum(item) },
            { title: 'IP Node',  render: (item, record) => <Link to={'/network/ip-nodes/' + record.ip_node.guid}>{record.ip_node.hostname.replace('.gateway.prioritynap.net', '')}</Link> },
            { title: 'Location', render: (item, record) => <Tooltip title={record.ip_node.location.city + ', ' + record.ip_node.location.country_name}><Flag code={record.ip_node.location.country.toLowerCase()} height={DEFAULT_FLAG_SIZE} /> {record.ip_node.location.city}</Tooltip> },
            { title: 'Provider', dataIndex: 'provider', render: (item, record) => record.ip_node.provider.name },
        ];

        return(
            <Fragment>
                <p>{this.showFilters()}</p>
                <Row justify='space-between' style={{marginBottom: '10px'}}>
                    <Col>
                        <Space>
                            <Button size='small' type='text' icon={<FilterOutlined />} onClick={() => this.setState({ showFiltersModal: true })}>Filters</Button>
                            <Button size='small' type='text' disabled={this.state.filters.length === 0} onClick={() => this.clearFilters()} icon={<DeleteOutlined />}>Clear Filters</Button>
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <Tooltip title='Reload' placement='left'><Button icon={<UndoOutlined />} size='small' type='circle' onClick={() => this.adminLoadIPAddresses()} /></Tooltip>
                            <Pagination onChange={(page, pageSize) => this.adminLoadIPAddresses(page, pageSize)} size='small' {...this.state.pagination} />
                        </Space>
                    </Col>
                </Row>
                <Table
                    columns={columns}
                    rowKey={(item) => item.guid}
                    dataSource={this.state.ipAddresses}
                    loading={this.state.loadingIPAddresses}
                    pagination={false}
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: this.state.selectedIPAddresses,
                        onChange: (ipAddresses) => this.setState({ selectedIPAddresses: ipAddresses })
                    }}
                    footer={() => <Row justify='space-between'>
                        <Col>{this.state.selectedIPAddresses.length + ' selected'}</Col>
                        <Col><Pagination onChange={(page, pageSize) => this.adminLoadIPAddresses(page, pageSize)} size='small' {...this.state.pagination} /></Col>
                    </Row>}

                />

                <IPAddressesTableFilter
                    showModal={this.state.showFiltersModal}
                    closeModal={() => this.setState({ showFiltersModal: false })}
                    onChange={(filter) => this.setFilter(filter) } />
            </Fragment>
        )
    }
}

export default connect(null, { updatePage, adminLoadIPAddresses })(IPAddressesTable);